import { TradingPhase } from "./tradingPhase";
import type { StockType } from "@utils/stockType";

export interface MarketStatusInput {
  pre_market_open_time?: number;
  regular_market_open_time?: number;
  regular_market_close_time?: number;
  post_market_close_time?: number;
  next_pre_market_open_time?: number;
  /** 港股午休开始 (12:00 HKT) */
  lunch_start_time?: number;
  /** 港股午休结束 (13:00 HKT) */
  lunch_end_time?: number;
}

/**
 * 获取市场交易状态
 * @param now 当前时间戳
 * @param marketData 交易时间数据
 * @param market 市场类型，US 用美股规则，HK 用港股规则
 */
export function getMarketStatus(
  now: number,
  marketData: MarketStatusInput,
  market?: StockType,
): TradingPhase {
  const {
    pre_market_open_time,
    regular_market_open_time,
    regular_market_close_time,
    post_market_close_time,
    next_pre_market_open_time,
    lunch_start_time,
    lunch_end_time,
  } = marketData || {};

  // 港股规则：午休、收市竞价、持续交易分段
  if (market === "HK") {
    if (
      lunch_start_time &&
      lunch_end_time &&
      now >= lunch_start_time &&
      now < lunch_end_time
    ) {
      return TradingPhase.LUNCH;
    }
    if (
      regular_market_close_time != null &&
      post_market_close_time != null &&
      now >= regular_market_close_time &&
      now < post_market_close_time
    ) {
      return TradingPhase.CLOSING_AUCTION;
    }
    if (
      post_market_close_time != null &&
      now >= post_market_close_time &&
      now < (next_pre_market_open_time ?? Infinity)
    ) {
      return TradingPhase.CLOSED_MARKET;
    }
    if (
      pre_market_open_time != null &&
      regular_market_open_time != null &&
      now < pre_market_open_time
    ) {
      return TradingPhase.CLOSED_MARKET;
    }
    if (
      regular_market_open_time != null &&
      regular_market_close_time != null &&
      now >= regular_market_open_time &&
      now < regular_market_close_time
    ) {
      return TradingPhase.IN_MARKET;
    }
    if (
      pre_market_open_time != null &&
      regular_market_open_time != null &&
      now >= pre_market_open_time &&
      now < regular_market_open_time
    ) {
      return TradingPhase.PRE_MARKET;
    }
    return TradingPhase.CLOSED_MARKET;
  }

  // 美股规则 - 类型收窄后使用
  const pre = pre_market_open_time;
  const regOpen = regular_market_open_time;
  const regClose = regular_market_close_time;
  const post = post_market_close_time;
  const next = next_pre_market_open_time;

  if (pre != null && regOpen != null && now >= pre && now < regOpen) {
    return TradingPhase.PRE_MARKET;
  }
  if (regOpen != null && regClose != null && now >= regOpen && now < regClose) {
    return TradingPhase.IN_MARKET;
  }
  if (regClose != null && post != null && now >= regClose && now < post) {
    return TradingPhase.AFTER_MARKET;
  }
  if (
    (post != null && next != null && now >= post && now < next) ||
    (pre != null && now < pre) ||
    (pre == null && regOpen == null && post == null)
  ) {
    return TradingPhase.CLOSED_MARKET;
  }
  return TradingPhase.AFTER_MARKET;
}
